export const API_LINK = "https://api.ticketqueens.com/api.php";
export const UPLOAD_API_LINK = "https://api.ticketqueens.com/upload.php";
